import {
  UseMutateAsyncFunction,
  UseMutateFunction,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import {
  EmissionFactorCsvDataDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_EMISSION_FACTORS } from "../domain";

import { emissionFactorsApi } from "@api/services";
import { ACTION_GET_EMISSION_FACTORS, roleGuard } from "@api";

export const ACTION_UPDATE_EMISSION_FACTOR = "UPDATE_EMISSION_FACTOR";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

const exportEmissionFactorCsv = async (): Promise<EmissionFactorCsvDataDto[]> => {
  const response =
    await emissionFactorsApi.emissionFactorsControllerExportEmissionFactorsCsv();

  return response.data;
};

export const useExportEmissionFactorCsv = (
  user: UserProfileDto | null,
): {
  exportEmissionFactorCsv: UseMutateFunction<
    EmissionFactorCsvDataDto[],
    unknown,
    void,
    unknown
  >;
  exportEmissionFactorCsvAsync: UseMutateAsyncFunction<
    EmissionFactorCsvDataDto[],
    unknown,
    void,
    unknown
  >;
  exportEmissionFactorCsvEnabled: boolean;
  isSuccessExportEmissionFactorCsv: boolean;
  isPendingExportEmissionFactorCsv: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, isSuccess, isPending, data } = useMutation({
    mutationKey: [DOMAIN_EMISSION_FACTORS, ACTION_UPDATE_EMISSION_FACTOR],
    mutationFn: enabled ? exportEmissionFactorCsv : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [DOMAIN_EMISSION_FACTORS, ACTION_GET_EMISSION_FACTORS],
      });
    },
  });

  return {
    exportEmissionFactorCsv: mutate,
    exportEmissionFactorCsvAsync: mutateAsync,
    exportEmissionFactorCsvEnabled: enabled,
    isSuccessExportEmissionFactorCsv: isSuccess,
    isPendingExportEmissionFactorCsv: isPending,
  };
};
